import { defineMessages, type MessageDescriptor } from 'react-intl';

export type ClinicianTrialRecapTestimonialVariant = 'us' | 'ca' | 'au' | 'nz';

export type ClinicianTrialRecapTestimonialCopy = {
  quote: MessageDescriptor;
  author: MessageDescriptor;
  location: MessageDescriptor;
};

/** react-intl messages for the Clinician upgrade modal trial-recap testimonial (right panel). */
export const clinicianTrialRecapTestimonialMessages = defineMessages({
  usQuote: {
    id: 'ye7oSdCxet',
    defaultMessage:
      '“I use Heidi Evidence every day. It has become part of how I work as a resident.”',
    description:
      'US testimonial quote on the Clinician upgrade modal trial-recap variant (right panel)',
  },
  usAuthor: {
    id: 'o9gpQ+6NPZ',
    defaultMessage: 'Dr Giuseppe Ingrasci',
    description:
      'US testimonial attribution name on the Clinician upgrade modal trial-recap variant',
  },
  usLocation: {
    id: 'Oy2CV3+WjX',
    defaultMessage: 'San Diego, USA',
    description:
      'US testimonial attribution location on the Clinician upgrade modal trial-recap variant',
  },
  caQuote: {
    id: 'RuiNVr/GWP',
    defaultMessage:
      '“Fast, reliable, and well-sourced, with guidelines localised to my country. Having it at my fingertips is incredibly useful.”',
    description:
      'Canada testimonial quote on the Clinician upgrade modal trial-recap variant (right panel)',
  },
  caAuthor: {
    id: 'x6SE1EZtTZ',
    defaultMessage: 'Dr Paul Hacker',
    description:
      'Canada testimonial attribution name on the Clinician upgrade modal trial-recap variant',
  },
  caLocation: {
    id: 'V7goXvUFql',
    defaultMessage: 'Community Palliative Medicine Associates, Canada',
    description:
      'Canada testimonial attribution location on the Clinician upgrade modal trial-recap variant',
  },
  nzQuote: {
    id: 'Hamr9VC623',
    defaultMessage:
      '“Heidi Evidence helps me find broad, credible evidence quickly, and I can use it directly in clinic letters. The transparency around guidelines and studies makes it easy to trust.”',
    description:
      'New Zealand testimonial quote on the Clinician upgrade modal trial-recap variant (right panel)',
  },
  nzAuthor: {
    id: '7TUsbsqvo6',
    defaultMessage: 'Dr Sarit Hochberg-Klein',
    description:
      'New Zealand testimonial attribution name on the Clinician upgrade modal trial-recap variant',
  },
  nzLocation: {
    id: 'PrxXUaOAZk',
    defaultMessage: 'New Zealand',
    description:
      'New Zealand testimonial attribution location on the Clinician upgrade modal trial-recap variant',
  },
  auQuote: {
    id: 'IhT7/lmyzo',
    defaultMessage:
      '“I use Heidi Evidence almost every day. As a family physician, it helps me find evidence-based answers quickly. I also appreciate that every response starts with the sources.”',
    description:
      'Testimonial quote shown on the right panel of the Clinician upgrade modal when a fake-clinician-trial user has fewer than 7 days remaining',
  },
  auAuthor: {
    id: 'cZSEjHCLU5',
    defaultMessage: 'Dr Miriam Blashki',
    description:
      'Australia/default region testimonial attribution name on the Clinician upgrade modal trial-recap variant',
  },
  auLocation: {
    id: 'f/7ClNLhoq',
    defaultMessage: 'Honeycomb Health, Australia',
    description:
      'Australia/default region testimonial attribution location on the Clinician upgrade modal trial-recap testimonial',
  },
});

/** Regional testimonial copy for the Clinician upgrade modal trial-recap right panel. */
export const CLINICIAN_TRIAL_RECAP_TESTIMONIAL_COPY: Record<
  ClinicianTrialRecapTestimonialVariant,
  ClinicianTrialRecapTestimonialCopy
> = {
  us: {
    quote: clinicianTrialRecapTestimonialMessages.usQuote,
    author: clinicianTrialRecapTestimonialMessages.usAuthor,
    location: clinicianTrialRecapTestimonialMessages.usLocation,
  },
  ca: {
    quote: clinicianTrialRecapTestimonialMessages.caQuote,
    author: clinicianTrialRecapTestimonialMessages.caAuthor,
    location: clinicianTrialRecapTestimonialMessages.caLocation,
  },
  nz: {
    quote: clinicianTrialRecapTestimonialMessages.nzQuote,
    author: clinicianTrialRecapTestimonialMessages.nzAuthor,
    location: clinicianTrialRecapTestimonialMessages.nzLocation,
  },
  au: {
    quote: clinicianTrialRecapTestimonialMessages.auQuote,
    author: clinicianTrialRecapTestimonialMessages.auAuthor,
    location: clinicianTrialRecapTestimonialMessages.auLocation,
  },
};
